export default __webpack_public_path__ + "static/card-1-bb07a1b38d00cbbd07310f13125552c3.png";